export const getWeekDay = (day, year, month) => {
  const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const today = new Date(year, month, day);
  return days[today.getDay()];
};
